import { Spinner } from '@components/ui/Primitives'
import React from 'react'
import { ReportHeader, ReportHeaderTitle, ReportHeaderTitleGroup } from './interactive.styled'

type Props = {
  title: React.ReactNode
  isRefreshing?: boolean
  children?: React.ReactNode
}

export const ReportTitleHeader: React.FC<Props> = ({ title, isRefreshing, children }) => (
  <ReportHeader>
    <ReportHeaderTitleGroup>
      <ReportHeaderTitle>{title}</ReportHeaderTitle>
      {isRefreshing && <Spinner size={14} margin={0} />}
    </ReportHeaderTitleGroup>
    {children}
  </ReportHeader>
)
